import { render, staticRenderFns } from "./mainDir.vue?vue&type=template&id=e1a6504a"
import script from "./mainDir.vue?vue&type=script&lang=js"
export * from "./mainDir.vue?vue&type=script&lang=js"
import style0 from "./mainDir.vue?vue&type=style&index=0&id=e1a6504a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports